module.exports = __webpack_public_path__ + "static/media/avenir-next-regular.272bf9bb.woff";